export const marketplace = {
  marketplaceSearchInputPlaceholderTitle: 'Sök',
  marketplaceDetailsCurtainCopyOptionTitle: 'Kopiera länk',
  marketplaceDetailsCurtainFlagOptionTitle: 'Rapportera innehåll',
  marketplaceDetailsCurtainCopiedAlertText: 'Länk kopierad!',
  marketplaceDetailsFlagCurtainTitle: 'Rapportera',
  marketplaceReportedCurtainContent: 'Innehåll rapporterat',
  marketplaceAllItems: 'Alla föremål',
  marketplaceWantToBuy: 'Vill köpa {item} från {appname}'
}
